import { render, staticRenderFns } from "./EditBenefit.vue?vue&type=template&id=024e2f82&"
import script from "./EditBenefit.vue?vue&type=script&lang=js&"
export * from "./EditBenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports